'use client';
import { ButtonFragmentFragment, TypeButton } from '@fm-nx/contentful-types';
import { LazyMotion, m as motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import classNames from 'classnames';
import { PageContentTypes } from '@fm-nx/constants';
const loadFeatures = () => import('../__constants__/framer-features').then((res) => res.default);
const LinkWrapper = dynamic(() => import('../link-wrapper/link-wrapper'), {
    ssr: false,
});
type ButtonPropTypes = {
    button: TypeButton<'WITHOUT_UNRESOLVABLE_LINKS'> | ButtonFragmentFragment;
    buttonType?: 'solid' | 'outline-dark' | 'outline-white';
};

export const Button = (props: ButtonPropTypes) => {
    // const { track, page, identify } = useNinetailed();
    const { button, buttonType = 'solid' } = props;
    const btnProp = 'fields' in button ? button.fields : button;
    const { buttonText, linkPage, linkPath } = btnProp;
    const linkPageProp = linkPage && 'fields' in linkPage ? linkPage.fields : linkPage;
    const slug = linkPageProp?.slug ? linkPageProp.slug.toString() : undefined;
    const contentType = linkPage && 'fields' in linkPage ? linkPage.sys.contentType.sys.id : linkPage?.__typename;
    // SDK gives a lowercase content type id (`pageTechnology`); GraphQL gives a
    // capitalized __typename (`PageTechnology`). Normalize before matching so
    // both button shapes resolve to a page type.
    const normalizedContentType = contentType ? contentType.charAt(0).toLowerCase() + contentType.slice(1) : undefined;
    const pageType = Object.values(PageContentTypes).find(
        (value) => value === normalizedContentType
    ) as keyof typeof PageContentTypes;

    const buttonClasses = classNames({
        'btn-circle-solid': buttonType === 'solid',
        'btn-circle-outline-dark': buttonType === 'outline-dark',
        'btn-circle-outline-white': buttonType === 'outline-white',
    });

    return (
        <LinkWrapper
            slug={slug}
            pageType={pageType}
            href={linkPath?.toString()}
            // onClick={() => {
            //     track('CTA Button Click');
            // }}
        >
            <LazyMotion features={loadFeatures}>
                <motion.span className={`btn ${buttonClasses}`}>
                    <span className="pointer-events-none">{buttonText?.toString()}</span>
                </motion.span>
            </LazyMotion>
        </LinkWrapper>
    );
};

export default Button;
